export const favoriteRadios = [
  {
    id: 'r01',
    name: 'Radio Éxito',
    slug: 'radio-exito',
    image: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20logo%20minimalist%20sound%20wave%20design%20warm%20coral%20and%20cream%20gradient%20clean%20geometric%20abstract%20composition%20studio%20branding%20identity&width=200&height=200&seq=fav-radio-exito&orientation=squarish',
    genre: 'Pop Latino',
    location: 'Ciudad de México',
    followers: 45800,
    isLive: true,
    currentShow: 'Éxitos de la Mañana',
    following: true,
    notifications: true,
    followedSince: '2026-05-10',
    frequency: 'Diario',
  },
  {
    id: 'r02',
    name: 'Radio Ritmo',
    slug: 'radio-ritmo',
    image: 'https://readdy.ai/api/search-image?query=Radio%20station%20brand%20logo%20abstract%20rhythm%20wave%20design%20emerald%20green%20and%20gold%20gradient%20minimalist%20geometric%20clean%20broadcasting%20identity&width=200&height=200&seq=fav-radio-ritmo&orientation=squarish',
    genre: 'Reggaetón y Urbano',
    location: 'San Juan, PR',
    followers: 72300,
    isLive: true,
    currentShow: 'Ritmo Urbano',
    following: true,
    notifications: true,
    followedSince: '2026-05-12',
    frequency: 'Frecuente',
  },
  {
    id: 'r03',
    name: 'La Clásica',
    slug: 'la-clasica',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20radio%20station%20logo%20elegant%20cream%20and%20burgundy%20design%20minimalist%20shield%20shape%20broadcasting%20branding%20clean%20studio%20identity&width=200&height=200&seq=fav-radio-clasica&orientation=squarish',
    genre: 'Clásicos 80s/90s',
    location: 'Buenos Aires, AR',
    followers: 29100,
    isLive: false,
    currentShow: null,
    following: true,
    notifications: false,
    followedSince: '2026-05-20',
    frequency: 'Ocasional',
  },
  {
    id: 'r04',
    name: 'RFW Noticias',
    slug: 'rfw-noticias',
    image: 'https://readdy.ai/api/search-image?query=News%20radio%20station%20logo%20minimalist%20clean%20navy%20and%20silver%20design%20geometric%20abstract%20globe%20shape%20professional%20broadcasting%20branding%20identity&width=200&height=200&seq=fav-radio-noticias&orientation=squarish',
    genre: 'Noticias',
    location: 'Madrid, ES',
    followers: 91500,
    isLive: true,
    currentShow: 'Informativo 24',
    following: true,
    notifications: false,
    followedSince: '2026-06-01',
    frequency: 'Diario',
  },
  {
    id: 'r05',
    name: 'ElectroBeat',
    slug: 'electrobeat',
    image: 'https://readdy.ai/api/search-image?query=Electronic%20music%20radio%20station%20logo%20minimalist%20neon%20violet%20and%20cyan%20design%20abstract%20sound%20wave%20grid%20broadcasting%20branding%20clean%20identity&width=200&height=200&seq=fav-radio-electrobeat&orientation=squarish',
    genre: 'Electrónica',
    location: 'Barcelona, ES',
    followers: 38100,
    isLive: true,
    currentShow: 'Deep Sessions',
    following: true,
    notifications: true,
    followedSince: '2026-05-25',
    frequency: 'Frecuente',
  },
];

export const favoritePrograms = [
  {
    id: 'p01',
    name: 'Éxitos de la Mañana',
    slug: 'exitos-manana',
    image: 'https://readdy.ai/api/search-image?query=Morning%20radio%20show%20branding%20logo%20warm%20sunrise%20orange%20and%20yellow%20minimalist%20design%20clean%20geometric%20sun%20icon%20studio%20identity&width=200&height=200&seq=fav-prog-manana&orientation=squarish',
    station: 'Radio Éxito',
    stationId: 'r01',
    host: 'Carlos Mendoza y Ana Vega',
    schedule: 'L-V 6:00 - 10:00',
    genre: 'Entretenimiento',
    days: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes'],
    following: true,
    notifications: true,
    onAir: true,
    nextEpisode: 'Hoy 6:00 AM',
  },
  {
    id: 'p02',
    name: 'Ritmo Urbano',
    slug: 'ritmo-urbano',
    image: 'https://readdy.ai/api/search-image?query=Urban%20radio%20show%20branding%20logo%20bold%20emerald%20green%20and%20black%20minimalist%20design%20clean%20geometric%20abstract%20sound%20block%20studio%20identity&width=200&height=200&seq=fav-prog-urbano&orientation=squarish',
    station: 'Radio Ritmo',
    stationId: 'r02',
    host: 'DJ Lúcido',
    schedule: 'L-S 14:00 - 18:00',
    genre: 'Urbano',
    days: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    following: true,
    notifications: true,
    onAir: true,
    nextEpisode: 'Hoy 2:00 PM',
  },
  {
    id: 'p03',
    name: 'Informativo 24',
    slug: 'informativo-24',
    image: 'https://readdy.ai/api/search-image?query=News%20radio%20program%20logo%20minimalist%20navy%20and%20white%20design%20clean%20geometric%20clock%20icon%20professional%20broadcast%20branding%20studio%20identity&width=200&height=200&seq=fav-prog-info24&orientation=squarish',
    station: 'RFW Noticias',
    stationId: 'r04',
    host: 'Laura Fernández',
    schedule: 'L-D 08:00 - 08:30',
    genre: 'Noticias',
    days: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
    following: true,
    notifications: false,
    onAir: false,
    nextEpisode: 'Mañana 8:00 AM',
  },
  {
    id: 'p04',
    name: 'Deep Sessions',
    slug: 'deep-sessions',
    image: 'https://readdy.ai/api/search-image?query=Deep%20house%20radio%20show%20logo%20minimalist%20violet%20gradient%20and%20dark%20indigo%20design%20clean%20abstract%20wave%20studio%20branding%20identity&width=200&height=200&seq=fav-prog-deep&orientation=squarish',
    station: 'ElectroBeat',
    stationId: 'r05',
    host: 'DJ Nova',
    schedule: 'S-D 22:00 - 02:00',
    genre: 'Deep House',
    days: ['Sábado', 'Domingo'],
    following: true,
    notifications: true,
    onAir: false,
    nextEpisode: 'Sábado 10:00 PM',
  },
  {
    id: 'p05',
    name: 'Clásicos de Oro',
    slug: 'clasicos-oro',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20golden%20classics%20radio%20show%20logo%20warm%20amber%20and%20brown%20minimalist%20design%20retro%20vinyl%20record%20icon%20clean%20studio%20branding&width=200&height=200&seq=fav-prog-clasicos&orientation=squarish',
    station: 'La Clásica',
    stationId: 'r03',
    host: 'Roberto Castillo',
    schedule: 'L-V 18:00 - 20:00',
    genre: 'Clásicos',
    days: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes'],
    following: true,
    notifications: false,
    onAir: false,
    nextEpisode: 'Hoy 6:00 PM',
  },
  {
    id: 'p06',
    name: 'Pop sin Filtro',
    slug: 'pop-sin-filtro',
    image: 'https://readdy.ai/api/search-image?query=Pop%20radio%20show%20logo%20vibrant%20coral%20pink%20and%20white%20minimalist%20design%20clean%20geometric%20microphone%20icon%20studio%20branding%20identity&width=200&height=200&seq=fav-prog-popfilter&orientation=squarish',
    station: 'Radio Éxito',
    stationId: 'r01',
    host: 'María José Ruiz',
    schedule: 'L-V 10:00 - 13:00',
    genre: 'Pop',
    days: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes'],
    following: true,
    notifications: true,
    onAir: true,
    nextEpisode: 'Hoy 10:00 AM',
  },
];

export const favoriteLocutores = [
  {
    id: 'l01',
    name: 'Carlos Mendoza',
    slug: 'carlos-mendoza',
    photo: 'https://readdy.ai/api/search-image?query=Professional%20radio%20host%20portrait%20hispanic%20male%2040s%20warm%20friendly%20smile%20studio%20headphones%20clean%20background%20soft%20lighting%20editorial%20photography&width=200&height=200&seq=fav-locutor-carlos&orientation=squarish',
    role: 'Locutor Principal',
    station: 'Radio Éxito',
    shows: ['Éxitos de la Mañana'],
    genre: 'Entretenimiento',
    followers: 28400,
    following: true,
    notifications: true,
    onAir: true,
  },
  {
    id: 'l02',
    name: 'Ana Vega',
    slug: 'ana-vega',
    photo: 'https://readdy.ai/api/search-image?query=Professional%20radio%20host%20portrait%20latina%20female%2030s%20bright%20confident%20smile%20studio%20headphones%20clean%20background%20soft%20lighting%20editorial%20photography&width=200&height=200&seq=fav-locutor-ana&orientation=squarish',
    role: 'Co-Locutora',
    station: 'Radio Éxito',
    shows: ['Éxitos de la Mañana'],
    genre: 'Entretenimiento',
    followers: 19700,
    following: true,
    notifications: false,
    onAir: true,
  },
  {
    id: 'l03',
    name: 'DJ Lúcido',
    slug: 'dj-lucido',
    photo: 'https://readdy.ai/api/search-image?query=Professional%20radio%20DJ%20portrait%20afro-latino%20male%20late%2020s%20cool%20confident%20expression%20studio%20headphones%20clean%20background%20editorial%20photography&width=200&height=200&seq=fav-locutor-lucido&orientation=squarish',
    role: 'DJ Principal',
    station: 'Radio Ritmo',
    shows: ['Ritmo Urbano'],
    genre: 'Urbano',
    followers: 51200,
    following: true,
    notifications: true,
    onAir: true,
  },
  {
    id: 'l04',
    name: 'Laura Fernández',
    slug: 'laura-fernandez',
    photo: 'https://readdy.ai/api/search-image?query=Professional%20radio%20news%20anchor%20portrait%20female%20mid%2030s%20serious%20warm%20expression%20studio%20headphones%20clean%20background%20soft%20editorial%20photography&width=200&height=200&seq=fav-locutor-laura&orientation=squarish',
    role: 'Presentadora de Noticias',
    station: 'RFW Noticias',
    shows: ['Informativo 24'],
    genre: 'Noticias',
    followers: 63900,
    following: true,
    notifications: false,
    onAir: false,
  },
  {
    id: 'l05',
    name: 'DJ Nova',
    slug: 'dj-nova',
    photo: 'https://readdy.ai/api/search-image?query=Professional%20electronic%20music%20DJ%20portrait%20female%20late%2020s%20stylish%20calm%20expression%20studio%20headphones%20clean%20dark%20background%20editorial%20photography&width=200&height=200&seq=fav-locutor-nova&orientation=squarish',
    role: 'DJ Residente',
    station: 'ElectroBeat',
    shows: ['Deep Sessions'],
    genre: 'Electrónica',
    followers: 38700,
    following: true,
    notifications: true,
    onAir: false,
  },
  {
    id: 'l06',
    name: 'Roberto Castillo',
    slug: 'roberto-castillo',
    photo: 'https://readdy.ai/api/search-image?query=Professional%20radio%20host%20portrait%20hispanic%20male%2050s%20warm%20friendly%20smile%20studio%20headphones%20classic%20style%20clean%20background%20soft%20editorial%20photography&width=200&height=200&seq=fav-locutor-roberto&orientation=squarish',
    role: 'Locutor',
    station: 'La Clásica',
    shows: ['Clásicos de Oro'],
    genre: 'Clásicos',
    followers: 15300,
    following: true,
    notifications: false,
    onAir: false,
  },
];

export const favoriteStats = {
  totalFollowing: 17,
  radiosCount: 5,
  programsCount: 6,
  locutoresCount: 6,
  notificationsOn: 8,
  onAirNow: 5,
};